import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'amfe-flexible/index';
Vue.use(Vant);

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
